import * as React from "react";
import * as Model from "../../models";
import * as FormModel from "../../models/Forms";
import { StoreAccessor } from "../../util/StoreUtil";
import * as FormBehaviour from "./FormBehaviour";
import * as HokanApi from "../../api/hokan";
import DateUtil from "../../util/DateUtil";

// @inject()
// @observer
export default class Behaviour extends FormBehaviour.PdfBehaviour {
  displayName = "Behaviour";

  public getId(): number {
    return 87;
  }

  public createContent(): any {
    const res = new FormModel.PdOut.Core();
    res.values.create_date = DateUtil.currentDateStr();
    HokanApi.me()
      .then((x) => {
        if (x && x.data) {
          res.values.create_by = x.data.name;
        }
      })
      .catch((e) => {
        console.log(e);
      });
    return res;
  }

  public createDocumentType(): Model.Document.DocumentType {
    const res = new Model.Document.DocumentType();
    res.id = this.getId();
    return res;
  }

  public beforePost_pdf(doc: Model.Document.Document) {
    let total = 0;
    const checks = Array(18)
      .fill(0)
      .map((_, i) => `check_${i + 1}`);

    checks.forEach((check, i) => {
      console.log(doc.content.checks[check]);
      console.log(i % 3);
      if (doc.content.checks[check]) {
        total += i % 3;
      }
    });

    doc.content.values.total_point = total;
  }

  public beforeMount = () => {};
  public setPatient(
    doc: Model.Document.Document,
    pat: Model.Patient.Patient,
    sa: StoreAccessor
  ) {
    doc.patient = pat;
    HokanApi.me()
      .then(() => {
        sa.updateState();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  public buildElements_pdf(doc: Model.Document.Document, sa: StoreAccessor) {
    const saV = sa.generateChild(["content", "values"]);
    const saC = sa.generateChild(["content", "checks"]);

    const elements_t = [
      {
        name: "内容",
        content: (
          <div style={{ padding: 10 }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 10,
              }}
            >
              評価担当
              <div style={{ width: "inherit" }}>{saV.text("create_by")}</div>
            </label>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 10,
              }}
            >
              腫脹
              {saC.radio([
                {
                  label: "なし",
                  key: `check_1`,
                },
                {
                  label: "出口のみ；＜ 0.5cm",
                  key: `check_2`,
                },
                {
                  label: "＞ 0.5cmおよび/またはトンネル",
                  key: `check_3`,
                },
              ])}
            </label>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 10,
              }}
            >
              痂皮
              {saC.radio([
                {
                  label: "なし",
                  key: `check_4`,
                },
                {
                  label: "＜ 0.5cm",
                  key: `check_5`,
                },
                {
                  label: "＞ 0.5cm",
                  key: `check_6`,
                },
              ])}
            </label>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 10,
              }}
            >
              発赤
              {saC.radio([
                {
                  label: "なし",
                  key: `check_7`,
                },
                {
                  label: "＜ 0.5cm",
                  key: `check_8`,
                },
                {
                  label: "＞ 0.5cm",
                  key: `check_9`,
                },
              ])}
            </label>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 10,
              }}
            >
              疼痛
              {saC.radio([
                {
                  label: "なし",
                  key: `check_10`,
                },
                {
                  label: "軽度",
                  key: `check_11`,
                },
                {
                  label: "重度",
                  key: `check_12`,
                },
              ])}
            </label>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 10,
              }}
            >
              排膿
              {saC.radio([
                {
                  label: "なし",
                  key: `check_13`,
                },
                {
                  label: "漿液性",
                  key: `check_14`,
                },
                {
                  label: "膿性",
                  key: `check_15`,
                },
              ])}
            </label>
          </div>
        ),
      },
    ];

    const elements = [{ name: "内容", content: elements_t }];

    return elements;
  }
}
